/* Van Gogh kaleidoscope: a canvas kaleidoscope with mirrored petals.
   A "cell" of coloured glass chips (random polygons, rods and beads in the painting's palette) rotates;
   a thin wedge of it is mirrored around the circle. Drag to turn, pick painting / petals, shake the glass.
   No libraries. Markup: sections/kaleido-play.liquid */
(function () {
  'use strict';

  /* Painting names stay English in PAL (the product picker is matched by them); T() translates only what the player sees. */
  var LANG = String(document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var DICT = {
    ru: {
      'Shaken!': 'Шейк!',
      'Selected: {name}': 'Выбрано: {name}',
      'Pick it in the options': 'Выберите в настройках товара',
      'Starry Night on Rhône': 'Звёздная ночь над Роной',
      'Seascape at Sainte-Marie': 'Морской пейзаж у Сент-Мари',
      'Green Wheat Field at Auvers': 'Зелёное пшеничное поле в Овере',
      'Wheatfield with Crows': 'Пшеничное поле с воронами',
      'Wild Rose': 'Дикая роза',
      'Wheatfield with Cypresses': 'Пшеничное поле с кипарисами'
    },
    de: {
      'Shaken!': 'Geschüttelt!',
      'Selected: {name}': 'Ausgewählt: {name}',
      'Pick it in the options': 'Wählen Sie es in den Optionen aus',
      'Starry Night on Rhône': 'Sternennacht über der Rhône',
      'Seascape at Sainte-Marie': 'Meeresansicht bei Sainte-Marie',
      'Green Wheat Field at Auvers': 'Grünes Weizenfeld bei Auvers',
      'Wheatfield with Crows': 'Weizenfeld mit Raben',
      'Wild Rose': 'Wilde Rose',
      'Wheatfield with Cypresses': 'Weizenfeld mit Zypressen'
    },
    es: {
      'Shaken!': '¡Agitado!',
      'Selected: {name}': 'Seleccionado: {name}',
      'Pick it in the options': 'Elíjalo en las opciones',
      'Starry Night on Rhône': 'Noche estrellada sobre el Ródano',
      'Seascape at Sainte-Marie': 'Marina en Sainte-Marie',
      'Green Wheat Field at Auvers': 'Campo de trigo verde en Auvers',
      'Wheatfield with Crows': 'Campo de trigo con cuervos',
      'Wild Rose': 'Rosa silvestre',
      'Wheatfield with Cypresses': 'Campo de trigo con cipreses'
    },
    fr: {
      'Shaken!': 'Secoué !',
      'Selected: {name}': 'Sélectionné : {name}',
      'Pick it in the options': 'Choisissez-le dans les options',
      'Starry Night on Rhône': 'La Nuit étoilée sur le Rhône',
      'Seascape at Sainte-Marie': 'Marine à Sainte-Marie',
      'Green Wheat Field at Auvers': 'Champ de blé vert à Auvers',
      'Wheatfield with Crows': 'Champ de blé aux corbeaux',
      'Wild Rose': 'Rose sauvage',
      'Wheatfield with Cypresses': 'Champ de blé avec cyprès'
    },
    ar: {
      'Shaken!': 'تم الهز!',
      'Selected: {name}': 'تم الاختيار: {name}',
      'Pick it in the options': 'اختره من الخيارات',
      'Starry Night on Rhône': 'ليلة مرصعة بالنجوم فوق نهر الرون',
      'Seascape at Sainte-Marie': 'منظر بحري في سانت ماري',
      'Green Wheat Field at Auvers': 'حقل القمح الأخضر في أوفير',
      'Wheatfield with Crows': 'حقل قمح مع الغربان',
      'Wild Rose': 'وردة برية',
      'Wheatfield with Cypresses': 'حقل قمح مع أشجار السرو'
    }
  };
  function T(s, v) { var o = (DICT[LANG] || {})[s] || s; if (v) for (var k in v) o = o.split('{' + k + '}').join(v[k]); return o; }

  var PAL = {
    rhone:   { name: 'Starry Night on Rhône',     c: ['#071a4d', '#12358f', '#2f7bd6', '#7ec8f0', '#f6d144', '#fff2a6', '#0b1330', '#c98a2b'] },
    sea:     { name: 'Seascape at Sainte-Marie',  c: ['#1b57a8', '#4f9fd6', '#a7d8ee', '#ffffff', '#2a7d92', '#d9edf3', '#668fbd', '#efe4c4'] },
    wheat:   { name: 'Green Wheat Field at Auvers', c: ['#2c8a4a', '#7cc46a', '#c2e5a4', '#f2e6a2', '#e9d3f2', '#ffffff', '#17583a', '#e8a9c6'] },
    crows:   { name: 'Wheatfield with Crows',     c: ['#10287a', '#2d6fd2', '#f3b63a', '#e27b1f', '#7a3a12', '#f8d97c', '#080d26', '#5aa9e8'] },
    rose:    { name: 'Wild Rose',                 c: ['#1c5638', '#4cae6c', '#a9e1b6', '#ffffff', '#f4cad9', '#0b1d17', '#cbe9d7', '#7d9238'] },
    cypress: { name: 'Wheatfield with Cypresses', c: ['#e8c247', '#f7e18c', '#4f7c3a', '#173646', '#b8d6e8', '#ffffff', '#7bb1d0', '#38592a'] }
  };
  var ORDER = ['rhone', 'sea', 'wheat', 'crows', 'rose', 'cypress'];
  var TAU = Math.PI * 2;

  function rnd(a, b) { return a + Math.random() * (b - a); }
  function pick(a) { return a[Math.floor(Math.random() * a.length)]; }
  function hexA(hex, a) {
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + (n >> 16) + ',' + ((n >> 8) & 255) + ',' + (n & 255) + ',' + a + ')';
  }

  function makeChips(colors) {
    var chips = [], i, kinds = ['tri', 'tri', 'tri', 'quad', 'quad', 'rod', 'rod', 'bead', 'bead', 'leaf'];
    for (i = 0; i < 520; i++) {
      var r = Math.sqrt(Math.random()) * 1.05, a = rnd(0, TAU), big = i < 40;
      chips.push({
        k: big ? 'blob' : pick(kinds), x: Math.cos(a) * r, y: Math.sin(a) * r, s: big ? rnd(.16, .3) : rnd(.03, .12), rot: rnd(0, TAU),
        col: pick(colors), col2: pick(colors), alpha: big ? rnd(.22, .34) : rnd(.86, 1), sq: rnd(.5, 1), tx: 0, ty: 0, mv: 0
      });
    }
    return chips;
  }

  function init(root) {
    var cv = root.querySelector('[data-kp-canvas]'), ctx = cv.getContext('2d');
    var src = document.createElement('canvas'), sx = src.getContext('2d');
    var cell = document.createElement('canvas'), cx = cell.getContext('2d'); // the chips, drawn once; rotated copies go to src
    var hint = root.querySelector('[data-kp-hint]');
    var st = {
      key: 'rhone', petals: 9, theta: rnd(0, TAU), vel: .12, base: .12, size: 0, R: 0, dpr: 1, chips: [], flash: 0,
      drag: null, visible: true, raf: 0, last: 0, dirty: true, cellDirty: true,
      reduce: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches
    };
    if (st.reduce) st.base = 0, st.vel = 0;

    /* swatches */
    ORDER.forEach(function (k) {
      var b = root.querySelector('[data-kp-paint="' + k + '"] .kp__sw'), c = PAL[k].c;
      if (b) { b.style.setProperty('--a', c[1]); b.style.setProperty('--b', c[2]); b.style.setProperty('--c', c[4]); b.style.setProperty('--d', c[0]); }
    });

    function resize() {
      var w = cv.clientWidth; if (!w) return;
      st.dpr = Math.min(window.devicePixelRatio || 1, 2);
      st.size = Math.round(w * st.dpr); st.R = st.size / 2;
      cv.width = cv.height = src.width = src.height = cell.width = cell.height = st.size;
      st.dirty = true; st.cellDirty = true;
    }

    /* ---- chips ---- */
    function setPalette(key, quiet) {
      st.key = key; st.chips = makeChips(PAL[key].c);
      root.querySelectorAll('[data-kp-paint]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-kp-paint') === key ? 'true' : 'false'); });
      if (!quiet) st.flash = 1;
      st.dirty = true; st.cellDirty = true;
    }
    function setPetals(n, quiet) {
      st.petals = n;
      root.querySelectorAll('[data-kp-petals]').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-kp-petals') === n ? 'true' : 'false'); });
      if (!quiet) st.flash = .8;
      st.dirty = true;
    }
    function shake() {
      st.chips.forEach(function (c) {
        var r = Math.sqrt(Math.random()) * 1.05, a = rnd(0, TAU);
        c.tx = Math.cos(a) * r; c.ty = Math.sin(a) * r; c.mv = 1;
      });
      st.vel += (Math.random() < .5 ? -1 : 1) * rnd(4, 7); st.flash = .6; st.dirty = true;
      say(T('Shaken!'));
    }
    var hintTimer = 0;
    function say(t) {
      if (!hint) return; var idle = hint.getAttribute('data-idle');
      if (idle === null) { idle = hint.textContent; hint.setAttribute('data-idle', idle); }
      hint.textContent = t; clearTimeout(hintTimer); hintTimer = setTimeout(function () { hint.textContent = idle; }, 1600);
    }

    /* ---- drawing ---- */
    function chipPath(c, R) {
      var s = c.s * R, sx = cx;
      sx.beginPath();
      if (c.k === 'bead' || c.k === 'blob') { sx.arc(0, 0, s * (c.k === 'blob' ? 1 : .55), 0, TAU); }
      else if (c.k === 'rod') { sx.rect(-s * 1.1, -s * .16, s * 2.2, s * .32); }
      else if (c.k === 'quad') { sx.moveTo(-s * .8, -s * .5 * c.sq); sx.lineTo(s * .7, -s * .6); sx.lineTo(s * .9, s * .5 * c.sq); sx.lineTo(-s * .6, s * .7); sx.closePath(); }
      else if (c.k === 'leaf') { sx.moveTo(-s, 0); sx.quadraticCurveTo(0, -s * .75, s, 0); sx.quadraticCurveTo(0, s * .75, -s, 0); sx.closePath(); }
      else { sx.moveTo(-s * .8, s * .6); sx.lineTo(s * .9, s * .3 * c.sq); sx.lineTo(-s * .1, -s * .85); sx.closePath(); }
    }
    function drawCell() {
      var R = st.R, cols = PAL[st.key].c;
      cx.setTransform(1, 0, 0, 1, 0, 0); cx.clearRect(0, 0, st.size, st.size);
      cx.translate(R, R);
      for (var i = 0; i < st.chips.length; i++) {
        var c = st.chips[i], s = c.s * R;
        cx.save(); cx.translate(c.x * R, c.y * R); cx.rotate(c.rot);
        chipPath(c, R);
        var g = c.k === 'bead' ? cx.createRadialGradient(-s * .2, -s * .2, 0, 0, 0, s * .6) : cx.createLinearGradient(-s, -s, s, s);
        if (c.k === 'bead') { g.addColorStop(0, 'rgba(255,255,255,.85)'); g.addColorStop(.35, hexA(c.col, c.alpha)); g.addColorStop(1, hexA(c.col2, c.alpha)); }
        else { g.addColorStop(0, hexA(c.col, c.alpha)); g.addColorStop(1, hexA(c.col2, c.alpha * .9)); }
        cx.fillStyle = g; cx.fill();
        if (c.k !== 'blob') {
          cx.lineWidth = Math.max(1, R * .003); cx.strokeStyle = 'rgba(255,255,255,.28)'; cx.stroke();
          if (c.k !== 'rod' && c.k !== 'bead') { cx.beginPath(); cx.moveTo(-s * .5, s * .35); cx.lineTo(s * .2, -s * .45); cx.strokeStyle = 'rgba(255,255,255,.22)'; cx.stroke(); }
        }
        cx.restore();
      }
    }
    function drawSource() {
      var R = st.R, cols = PAL[st.key].c;
      if (st.cellDirty) { drawCell(); st.cellDirty = false; }
      sx.setTransform(1, 0, 0, 1, 0, 0);
      sx.fillStyle = cols[6] || '#0b1230'; sx.fillRect(0, 0, st.size, st.size);
      sx.translate(R, R); sx.rotate(st.theta); sx.drawImage(cell, -R, -R);
    }
    function render() {
      var R = st.R; if (!R) return;
      drawSource();
      var N = st.petals, half = Math.PI / N, step = TAU / N;
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.fillStyle = '#0b1230'; ctx.fillRect(0, 0, st.size, st.size);
      ctx.translate(R, R);
      for (var k = 0; k < N; k++) {
        for (var m = 0; m < 2; m++) {
          ctx.save(); ctx.rotate(k * step); if (m) ctx.scale(1, -1);
          ctx.beginPath(); ctx.moveTo(0, 0); ctx.arc(0, 0, R * 1.02, -.004, half + .004); ctx.closePath(); ctx.clip();
          ctx.drawImage(src, -R, -R);
          ctx.restore();
        }
      }
      if (st.flash > 0) {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.fillStyle = 'rgba(255,248,225,' + (st.flash * .55).toFixed(3) + ')'; ctx.fillRect(0, 0, st.size, st.size);
      }
    }

    /* ---- loop ---- */
    function frame(t) {
      st.raf = 0;
      var dt = st.last ? Math.min(.05, (t - st.last) / 1000) : .016; st.last = t;
      var moving = false;
      if (!st.drag) {
        st.theta += st.vel * dt;
        st.vel += (st.base - st.vel) * Math.min(1, dt * 1.8);
        if (Math.abs(st.vel) > .001) moving = true;
      }
      st.chips.forEach(function (c) {
        if (c.mv > 0) { c.x += (c.tx - c.x) * Math.min(1, dt * 5); c.y += (c.ty - c.y) * Math.min(1, dt * 5); c.mv -= dt; moving = true; st.cellDirty = true; }
      });
      if (st.flash > 0) { st.flash = Math.max(0, st.flash - dt * 2.2); moving = true; }
      if (moving || st.dirty || st.drag) { render(); st.dirty = false; }
      if (st.visible && (moving || st.drag || st.base)) { schedule(); } else { st.last = 0; }
    }
    function schedule() { if (!st.raf && st.visible) st.raf = requestAnimationFrame(frame); }
    function poke() { st.dirty = true; schedule(); }

    /* ---- input ---- */
    function ang(e) { var r = cv.getBoundingClientRect(); return Math.atan2(e.clientY - (r.top + r.height / 2), e.clientX - (r.left + r.width / 2)); }
    cv.addEventListener('pointerdown', function (e) {
      st.drag = { id: e.pointerId, x: e.clientX, a: ang(e), t: performance.now(), type: e.pointerType };
      try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      poke();
    });
    cv.addEventListener('pointermove', function (e) {
      var d = st.drag; if (!d || d.id !== e.pointerId) return;
      var now = performance.now(), dt = Math.max(.008, (now - d.t) / 1000), da;
      if (d.type === 'mouse') {
        var a = ang(e); da = a - d.a; if (da > Math.PI) da -= TAU; if (da < -Math.PI) da += TAU; d.a = a;
        da += (e.clientX - d.x) * .004; // plain sideways drags work too
      } else { da = (e.clientX - d.x) * .014; }
      d.x = e.clientX; d.t = now;
      st.theta += da; st.vel = Math.max(-8, Math.min(8, da / dt)) * .6 + st.vel * .4;
      poke();
    });
    function end(e) { if (st.drag && st.drag.id === e.pointerId) { st.drag = null; poke(); } }
    cv.addEventListener('pointerup', end); cv.addEventListener('pointercancel', end); cv.addEventListener('lostpointercapture', function () { st.drag = null; poke(); });
    cv.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { st.vel -= 2.5; poke(); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { st.vel += 2.5; poke(); e.preventDefault(); }
      else if (e.key === ' ' || e.key === 'Enter') { shake(); poke(); e.preventDefault(); }
    });

    root.querySelectorAll('[data-kp-paint]').forEach(function (b) {
      b.addEventListener('click', function () { setPalette(b.getAttribute('data-kp-paint')); poke(); });
    });
    root.querySelectorAll('[data-kp-petals]').forEach(function (b) {
      b.addEventListener('click', function () { setPetals(+b.getAttribute('data-kp-petals')); poke(); });
    });
    var sh = root.querySelector('[data-kp-shake]'); if (sh) sh.addEventListener('click', function () { shake(); poke(); });

    /* "Choose this one": select the matching painting and petals in the product picker, then scroll up to it */
    var pk = root.querySelector('[data-kp-pick]');
    /* option values are translated on /ru /de /es /fr /ar, so besides the English name the picker is matched by position
       (paintings and petals sit in the same order as ORDER and 9, 10) */
    function posIn(i) { var g = i.closest('[data-option-group]'); return g ? Array.prototype.indexOf.call(g.querySelectorAll('[data-option-input]'), i) : -1; }
    function choose(name, optIndex, pos) {
      var inputs = document.querySelectorAll('[data-option-input]'), hit = null;
      inputs.forEach(function (i) {
        var g = i.closest('[data-option-group]'), inGroup = optIndex == null || !g || +g.getAttribute('data-option-index') === optIndex;
        if (inGroup && (i.value.toLowerCase() === name.toLowerCase() || (pos != null && g && posIn(i) === pos))) hit = i;
      });
      if (hit && !hit.checked) hit.click();
      return !!hit;
    }
    if (pk) pk.addEventListener('click', function () {
      var ok = choose(PAL[st.key].name, 0, ORDER.indexOf(st.key)); choose(st.petals + ' petals', 1, st.petals === 9 ? 0 : 1);
      var target = document.querySelector('[data-option-group]') || document.querySelector('form[action*="/cart/add"]');
      if (target) { try { target.scrollIntoView({ behavior: st.reduce ? 'auto' : 'smooth', block: 'center' }); } catch (x) { target.scrollIntoView(); } }
      say(ok ? T('Selected: {name}', { name: T(PAL[st.key].name) }) : T('Pick it in the options'));
    });
    /* the product picker drives the preview too */
    document.addEventListener('change', function (e) {
      var t = e.target; if (!t || !t.matches || !t.matches('[data-option-input]')) return;
      var v = (t.value || '').toLowerCase();
      ORDER.forEach(function (k) { if (PAL[k].name.toLowerCase() === v && st.key !== k) { setPalette(k); poke(); } });
      var m = /^(9|10) petals$/.exec(v); if (m && st.petals !== +m[1]) { setPetals(+m[1]); poke(); }
      var tg = t.closest('[data-option-group]'), gi = tg ? +tg.getAttribute('data-option-index') : -1, tp = posIn(t);
      if (gi === 0 && ORDER[tp] && st.key !== ORDER[tp]) { setPalette(ORDER[tp]); poke(); }
      if (gi === 1 && (tp === 0 || tp === 1) && st.petals !== 9 + tp) { setPetals(9 + tp); poke(); }
    });

    /* visibility + size */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { st.visible = en[0].isIntersecting; if (st.visible) { st.last = 0; poke(); } }, { threshold: .05 }).observe(cv);
    }
    if ('ResizeObserver' in window) new ResizeObserver(function () { resize(); poke(); }).observe(cv); else window.addEventListener('resize', function () { resize(); poke(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { st.last = 0; poke(); } });

    root.__kp = st; // test hook
    setPalette('rhone', true); setPetals(9, true); resize(); poke();
  }

  function boot() { document.querySelectorAll('[data-kp]').forEach(function (r) { if (!r.__kp) init(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
